/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuccessWeightsInfoResponse } from '../models/SuccessWeightsInfoResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ObservationWeightControllerService {

    /**
     * Returns info about user's weight
     * @param startWeightDaysAgo
     * @returns SuccessWeightsInfoResponse OK
     * @throws ApiError
     */
    public static getWeightsInfo(
        startWeightDaysAgo: number,
    ): CancelablePromise<SuccessWeightsInfoResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/observations/weights',
            query: {
                'startWeightDaysAgo': startWeightDaysAgo,
            },
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

}
